export const APPLICATION_LEVEL_NODE_ID = 'app-level:application';

export enum DomainTreeNodeType {
  AppLevel = 'appLevel',
  Domain = 'domain',
  Path = 'path',
  Endpoint = 'endpoint',
  Webpage = 'webpage',
}

export type DomainTreeBuildEndpoint = {
  id: string;
  url: string;
  path: string;
  method: string;
  graphqlOperationName?: string | null;
  xmlOperationName?: string | null;
  xmlOperationDisplayName?: string | null;
  isArchived?: boolean;
};

export type DomainTreeBuildWebPage = {
  id: string;
  url: string;
  role?: string;
  isArchived?: boolean;
};

export type DomainTreeBuildAsset =
  | { type: 'endpoint'; data: DomainTreeBuildEndpoint }
  | { type: 'webpage'; data: DomainTreeBuildWebPage };

export type DomainTreeNode = {
  id: string;
  name: string;
  fullDomain: string;
  level: number;
  nodeType: DomainTreeNodeType;
  children: DomainTreeNode[];
  parent?: DomainTreeNode;
  assets: DomainTreeBuildAsset[];
  isExpanded: boolean;
  assetCount: number;
  fullPath?: string;
  method?: string;
  assetId?: string;
  isArchived?: boolean;
};

export type DomainTree = {
  roots: DomainTreeNode[];
  nodeMap: Map<string, DomainTreeNode>;
};

export type BuildDomainTreeOptions = {
  includeMethodNodes?: boolean;
  applyApplicationLevelRoot?: boolean;
};
